import React from 'react';
import cn from '@/utils/cn';
import { formattedUpdatedAt } from '@/components/staffer/Grading/utils';
import useGradingStore from '@/components/staffer/Grading/useGradingStore';
import styles from './questionCard.module.scss';

interface StudentAnswerInformationProps {
  updatedAt: string | null;
}

const StudentAnswerInformation = ({ updatedAt }: StudentAnswerInformationProps) => {
  const { student } = useGradingStore();
  const isUnanswered = updatedAt == null;

  if (!student) return null;

  return (
    <div className="tw-mt-2">
      <span className={cn(styles.studentName, { [styles.unanswered]: isUnanswered })}>
        {student.first_name} {student.last_name}&apos;s answer:
      </span>
      {!isUnanswered && (
        <span className="tw-ml-2 tw-text-dark-grey">
          Updated {formattedUpdatedAt(updatedAt)}
        </span>
      )}
    </div>
  );
};

export default StudentAnswerInformation;
